import GradeSheetsIndex from '@/views/grade-sheets/GradeSheetsIndex.vue';
import AddGradeSheet from '@/views/grade-sheets/AddGradeSheet.vue';
import EditGradeSheet from '@/views/grade-sheets/EditGradeSheet.vue';
import GradeSheetView from '@/views/grade-sheets/GradeSheetView.vue';

export default [
  {
    path: '/grade-sheets',
    name: 'grade-sheets.index',
    component: GradeSheetsIndex,
    meta: { 
      title: 'gradeSheets.indexTitle', 
      requiresAuth: true,
      requiredPerm: 'grade_sheets.display'
    },
    children: [
      {
        path: 'add',
        name: 'AddGradeSheet',
        component: AddGradeSheet,
        meta: { 
          title: 'gradeSheets.addTitle', 
          requiresAuth: true,
          requiredPerm: 'grade_sheets.create'
        }
      },
      {
        path: ':id/edit',
        name: 'EditGradeSheet',
        component: EditGradeSheet,
        meta: { 
          title: 'gradeSheets.editTitle', 
          requiresAuth: true,
          requiredPerm: 'grade_sheets.update'
        },
        props: true
      },
      {
        path: ':id',
        name: 'GradeSheetView',
        component: GradeSheetView,
        meta: { 
          title: 'gradeSheets.viewTitle', 
          requiresAuth: true,
          requiredPerm: 'grade_sheets.view'
        },
        props: true
      }
    ]
  }
];
